'use strict';

var MarketsLegsResponsibilitiesDirective = function MarketsLegsResponsibilitiesDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/markets-legs-responsibilities.html'),
    controller: 'MarketsLegsResponsibilitiesController',
    scope: {
      user: '=',
      isOwnProfile: '=',
      backToUserList: '=?'
    },
    link: function link($scope) {
      $scope.loadData().then($scope.fetchMarketsAndLegs);
    }
  };
};
MarketsLegsResponsibilitiesDirective.$inject = [];
module.exports = MarketsLegsResponsibilitiesDirective;